import styled from 'styled-components';
import { RightTooltip } from 'ui/tooltip';
import { colors } from 'ui/theme';

const Content = styled.span`
  color: ${colors.grey35};
`;

export const WebhookBodyNotSet = () => {
  return (
    <RightTooltip tooltipContent="Edit request to set a value">
      <Content>Not set</Content>
    </RightTooltip>
  );
};
